import {Utilisateur, UtilisateurInterface} from './../../../class/api/Utilisateur';
import {Mandat, MandatInterface} from './../../../class/api/Mandat';
import {HydraCollection} from './../../../class/generic/hydra-collection';
import {HydraService} from './../../../core/services/hydra.service';
import {api} from './../../../api/api-dictionnary';
import {ExComissionSeance} from './../../../class/ex/ex-comission-seance';
import { Component, OnInit, inject } from '@angular/core';
import {
    MAT_DIALOG_DATA,
    MatDialogRef,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatDialogTitle
} from '@angular/material/dialog';
import {ToolsService} from '../../services/tools/tools.service';
import {MandatType} from '../../../class/api/MandatType';
import {CommissionSeanceInterface} from '../../../class/api/CommissionSeance';
import {CommissionSeanceParticipationInterface} from '../../../class/api/CommissionSeanceParticipation';
import { CdkScrollable } from '@angular/cdk/scrolling';

import { MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';

@Component({
    selector: 'app-modal-add-utilisateur',
    template: `
        <h4 mat-dialog-title>Rechercher et ajouter un membre</h4>
        <hr/>
        <mat-dialog-content>
          <!--Recherche-->
          @if (userSelected === null) {
            <div class="row">
              <div class="col">
                <div class="form-group">
                  <label>Rechercher un membre</label>
                  <input
                    style="max-width: 500px"
                    type="text"
                    class="form-control pl-1"
                    placeholder="Membres"
                    aria-label="Membres"
                    matInput
                    [(ngModel)]="autoComplete"
                    (ngModelChange)="updateAutoComplete()"
                    />
                  </div>
                </div>
              </div>
            }
        
            <!--Liste de résultats avec séléction-->
            @if (users.length && userSelected === null) {
              <div class="row">
                <div class="col">
                  <div
                    class="users-listes"
                    style="max-height:300px;padding-right: 15px;overflow-y: auto;display: block;"
                    >
                    <p>Résultats :</p>
                    <table
                      class="table table-striped table-bordered table-sm "
                      >
                      <thead>
                        <tr>
                          <th>Nom</th>
                          <th>Prénom</th>
                          <th>Email</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (user of users; track user) {
                          <tr>
                            <td>{{ user.nom }}</td>
                            <td>{{ user.prenom }}</td>
                            <td>{{ user.email }}</td>
                            <td>
                              <button
                                class="btn-small"
                                (click)="selectUser(user)"
                                mat-raised-button
                                >
                                Séléctionner
                              </button>
                            </td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            }
        
            @if (userSelected !== null) {
              <div>
                <div class="row">
                  <div class="col">
                    <button
                      (click)="userSelected = null"
                      style="float: right"
                      class="btn-small"
                      mat-stroked-button
                      color="warn"
                      >
                      <i class="fas fa-undo"></i> Revenir à la liste des
                      résultats
                    </button>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <p>
                      Création d'un mandat pour le membre :
                      <strong
                        >{{ userSelected.civilite }}.
                        {{ userSelected.nom }}
                        {{ userSelected.prenom }}</strong
                        >
                      </p>
                    </div>
                  </div>
                  @if (allowModificationDatesMandat) {
                    <div class="row">
                      <div class="col">
                        <div class="form-group">
                          <label for="dateDebut">Date de début</label>
                          <input
                            type="date"
                            name="dateDebut"
                            id="dateDebut"
                            [(ngModel)]="mandat.dateDebut"
                            class="form-control"
                            required
                            />
                          </div>
                        </div>
                        <div class="col">
                          <div class="form-group">
                            <label for="dateFin">Date de fin</label>
                            <input
                              type="date"
                              name="dateFin"
                              id="dateFin"
                              [(ngModel)]="mandat.dateFin"
                              class="form-control"
                              required
                              />
                            </div>
                          </div>
                        </div>
                      }
                      <div class="row">
                        <div class="col">
                          <label for="Commission">Commission :</label>
                          <input
                            type="text"
                            name="Commission"
                            id="Commission"
                                value="{{ commissionSeance.commission?.code }} - {{
                                commissionSeance.commission?.label
                            }}"
                            class="form-control"
                            disabled
                            />
                          </div>
                          <div class="col">
                            <div class="form-group">
                              <label>Type de mandat : </label>
                              <mat-select
                                class="form-control"
                                placeholder="Type de mandat"
                                [(ngModel)]="mandat.mandatType"
                                >
                                @for (mandaType of mandatTypes; track mandaType) {
                                  <mat-option
                                    [value]="mandaType"
                                    >
                                    {{ mandaType?.label }}
                                  </mat-option>
                                }
                              </mat-select>
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                    <br/>
                  </mat-dialog-content>
                  <mat-dialog-actions>
                    <button mat-button [mat-dialog-close]="false">Annuler</button>
                    <button
                      (click)="createMandat()"
                      mat-raised-button
                      color="accent"
                      [disabled]="!users.length"
                      >
                      Créer le mandat et ajouter aux participants
                    </button>
                  </mat-dialog-actions>
        `,
    styleUrls: ['./modal-add-utilisateur.component.scss'],
    imports: [CdkScrollable, MatDialogContent, MatInput, FormsModule, MatButton, MatSelect, MatOption, MatDialogActions, MatDialogClose, MatDialogTitle]
})
export class ModalAddUtilisateurComponent implements OnInit {
    dialogRef = inject<MatDialogRef<ModalAddUtilisateurComponent>>(MatDialogRef);
    private toolService = inject(ToolsService);
    private hydraService = inject(HydraService);
    data = inject<{
    reunion: CommissionSeanceInterface;
    allowModificationDatesMandat: boolean;
}>(MAT_DIALOG_DATA);

    public commissionSeance: ExComissionSeance      = null;
    public allowModificationDatesMandat    = true;

    public autoComplete = '';
    public users: UtilisateurInterface[] = [];
    public userSelected: UtilisateurInterface = null;
    public mandat = new Mandat();
    public mandatTypes: MandatType[] = [];

    public usersIRIAlreadyHavingParticipation: string[] = [];

    constructor() {
        const data = this.data;

        this.commissionSeance = new ExComissionSeance(data.reunion);
        this.allowModificationDatesMandat = data.allowModificationDatesMandat;

        this.mandat.dateDebut = this.toolService.convertDateForFront(
            new Date().toISOString()
        );
        this.mandat.dateFin = this.toolService.convertDateForFront(
            this.commissionSeance.datetimeFin
        );

        this.mandat.commission = this.commissionSeance.commission['@id'];

        this.usersIRIAlreadyHavingParticipation =
            (data.reunion.commissionSeanceParticipations as CommissionSeanceParticipationInterface[])
                .map(
                    participation => HydraService.extractIRI((participation.mandat as MandatInterface).utilisateur)
                );
    }

    _timer: any = null;

    public updateAutoComplete() {
        if (this._timer != null) {
            window.clearTimeout(this._timer);
        }
        if (this.autoComplete && this.autoComplete.length > 2)
            {this._timer = window.setTimeout(() => {

                const url = api.experts + '?search=' + this.autoComplete + '&pagination=false';
                this.hydraService
                    .getList(url)
                    .subscribe((res: HydraCollection) => {
                        this.users = (res.getMember() as UtilisateurInterface[]).filter(
                            item => !this.usersIRIAlreadyHavingParticipation.includes(item['@id'])
                        );
                    });
            }, 250);}
    }

    public selectUser(user: Utilisateur) {
        this.userSelected = user;
        this.mandat.utilisateur = user['@id'];
    }

    public createMandat() {
        const dataForSave = {...this.mandat};
        dataForSave.mandatType = dataForSave.mandatType['@id'];
        this.hydraService
            .save(api.mandats, dataForSave)
            .subscribe((res: Mandat) => {
                this.dialogRef.close(res);
            });
    }

    ngOnInit() {
        this.hydraService
            .getList(api.mandatType)
            .subscribe((res: HydraCollection) => {
                this.mandatTypes = res.getMember().map(item => new MandatType(item));
                this.mandat.mandatType = this.mandatTypes[0];
            });
    }
}
